import { Component, OnInit, Input } from '@angular/core';
import { KeyDatesService } from 'src/app/shared/services/keydates.service';
import { faPlus, faPen, faHistory } from '@fortawesome/free-solid-svg-icons';
import { AddKeyDateComponent } from './add-key-date/add-key-date.component';
import { CancelCaseComponent } from './cancel-case/cancel-case.component';
import { AuthService } from 'src/app/auth/auth.service';
import { DeleteKeyDateComponent } from './delete-key-date/delete-key-date.component';
import { SelectConsultantComponent } from '../../../calendar/select-consultant/select-consultant.component';
import { CaseService } from 'src/app/shared/services/case.service';
import { KeyDatesHistoryComponent } from './key-dates-history/key-dates-history.component';
import { Subscription } from 'rxjs';
import { ModalService } from 'src/app/shared/services/modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { YesNoPopupComponent } from 'src/app/shared/components/yes-no-popup/yes-no-popup.component';
import { OkPopupComponent } from 'src/app/shared/components/ok-popup/ok-popup.component';



@Component({
  selector: 'app-key-dates',
  templateUrl: './key-dates.component.html',
  styleUrls: ['./key-dates.component.scss']
})
export class KeyDatesComponent implements OnInit {

  @Input() caseId: number;
  @Input() readOnly: boolean = true;
  @Input() caseTypeId?: number;
  keyDateTypes: any[] = [];
  caseKeyDates: any[] = [];
  viewInit = false;

  faPlus = faPlus;
  faPen = faPen;
  faHistory = faHistory;
  isMobile = false;

  keyDatesLoaded = false;

  refreshSubscription: Subscription;

  constructor( public activeModal: NgbActiveModal,
               private keyDatesService: KeyDatesService,
               public authService: AuthService,
               private caseService: CaseService,
               public modalService: ModalService
              ) {

      this.refreshSubscription = this.keyDatesService.refreshKeyDatesObservable.subscribe(() => {
        this.loadKeyDates();
      });
  }


  ngOnInit() {

  }

  ngAfterContentInit() {
    this.viewInit = true;
    this.loadKeyDates();
  }

  loadKeyDates() {
    if (!this.viewInit) return;

    this.keyDatesService.getKeyDatesForCase(this.caseId).subscribe((response: any) => {

      var keyDatesForCase = response.keyDates;

      this.keyDatesService.getKeyDateTypes(this.caseId).subscribe((result: any) => {

        this.keyDateTypes = result.keyDatesTypes;

        type KeyDateObjType = Array<{ keyDateTypeId: number, keyDateName: string, canEdit: boolean, keyDateId: number, keyDateValue: string, enteredByUser: any, includeTime: boolean }>;
        var keyDatesArray: KeyDateObjType = [];

        this.keyDateTypes.forEach(keyDateType => {

          var keyDateObj: any;

          var matchFound = false;

          keyDatesForCase.forEach((keyDate: any)  => {

            if (keyDate.keyDateType == keyDateType.keyDateTypeId) {
              matchFound = true;
              keyDateObj = { keyDateTypeId: keyDateType.keyDateTypeId, keyDateName: keyDateType.keyDateType.name, canEdit: keyDateType.keyDateType.canEdit, keyDateId: keyDate.id, keyDateValue: keyDate.value, enteredByUser: keyDate.enteredByUser, includeTime: keyDateType.keyDateType.includeTime };
            }

          });

          if (matchFound)
            keyDatesArray.push(keyDateObj);
          else
            keyDatesArray.push({ keyDateTypeId: keyDateType.keyDateTypeId, keyDateName: keyDateType.keyDateType.name, canEdit: keyDateType.keyDateType.canEdit, keyDateId: -1, keyDateValue: '', enteredByUser: null, includeTime: keyDateType.keyDateType.includeTime });

        });

        this.caseKeyDates = keyDatesArray;

        this.keyDatesLoaded = true;


      });

    });
  }

  ctpCheck(event:any) {

    const modalRef = this.modalService.open(OkPopupComponent);    
    modalRef.componentInstance.messageHeader = 'Mortgage Details';
    modalRef.componentInstance.popupText1 = 'Please check the mortgage details have been updated on the case';
    modalRef.componentInstance.popupText2 = '';
 
  }

  addKeyDate(event:any) {

    if(this.canAddKeyDate(event))
      this.showKeyDateAddPopup(event);
  }

  showKeyDateAddPopup(event:any){


      const modalRef = this.modalService.openWithOptions(AddKeyDateComponent, {size: 'md'});
             
      modalRef.componentInstance.caseId = this.caseId;
      modalRef.componentInstance.keyDateTypeId = event.typeId,
      modalRef.componentInstance.keyDateId = null; 
      modalRef.componentInstance.keyDateValue = null; 
      modalRef.componentInstance.keyDateName = event.keyDateName;
  
      modalRef.result.then(
        (result) => {
          if(result)
        {
        this.loadKeyDates();

        this.caseService.refreshCase.next();

        // Offer Received or Scheduled Prepared Pack
        if (event.typeId == 13 || event.typeId == 16) {
          this.showTravellingConsultants();
        }

        // Shortfall Identified
        if (event.typeId == 97)
        {
          const modalRef = this.modalService.open(OkPopupComponent);
          modalRef.componentInstance.popupText1 ='Please obtain source of funds from the client, the Shortfall Value approximate amount must be immediately completed on the ‘Main Case’ details screen';

          //this.caseService.refreshCase.next();
          //this.caseService.refreshShortfall.next();
        }

        //Provisional Completion Date or Exchange
        if (event.typeId == 22 || event.typeId == 59)
        {

          const modalRef = this.modalService.open(OkPopupComponent);
          modalRef.componentInstance.popupText1 ='Please correct if necessary the Shortfall Amount details on the ‘Main Case’ details screen';
          
          modalRef.result.then(
            (result) => {

            if(event.typeId == 59)
            {
              this.keyDatesService.getKeyDateValue(this.caseId, 109).subscribe(response => {
                
                if(response.keyDateValue == null){
                  this.keyDatesService.getKeyDateValue(this.caseId, 59).subscribe(response => {

                    const modalRef = this.modalService.openWithOptions(AddKeyDateComponent, {size: 'md'});
                                
                    modalRef.componentInstance.keyDateTypeId = 109,
                    modalRef.componentInstance.keyDateId = null; 
                    modalRef.componentInstance.keyDateValue = response.keyDateValue; 
                    modalRef.componentInstance.keyDateName = "Agreed Completion Date";
                
                    modalRef.result.then(
                      (result) => {
                         if (result == true)
                        this.keyDatesService.refreshKeyDates.next();
                    },
                      () => {} // dismissed - do nothing
                    );

                  });
                }
              });
            }
          },
            () => {} // dismissed - do nothing
          );
        }

        if(event.typeId == 26) // fileClosure
          this.activeModal.close("fileClosed");
      }
    },
    () => {} // dismissed - do nothing
    );

  }

  canAddKeyDate(event:any){


    if(event.typeId != 13) // Offer Received
    {
      return true;
    }
    else{

      const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, {size: 'lg'});
          
      modalRef.componentInstance.messageHeader = '';
      modalRef.componentInstance.popupText1 = 'Has the Lender, Lenders Solicitor including e-mail and their reference number been completed for the automation e-mails to work properly?';
      modalRef.componentInstance.popupText2 = '';

      modalRef.result.then(
        (result) => {
        if(!result) // call to trigger event to fire auto email
        {
          const modalRef = this.modalService.open(OkPopupComponent);
          modalRef.componentInstance.popupText1 ='Please Complete';
          return false;
        }
        else{
          this.showKeyDateAddPopup(event);
          return true;
        }
      },
        () => {} // dismissed - do nothing
      );

      return false;
    }



  }

  editKeyDate(event:any) {
    //No longer needed

  }

  deleteKeyDate(event:any) {

     const modalRef = this.modalService.openWithOptions(DeleteKeyDateComponent, {size: 'md'});
             
      modalRef.componentInstance.caseId = this.caseId;
      modalRef.componentInstance.keyDateTypeId = event.typeId,
      modalRef.componentInstance.keyDateId = event.keyDateId; 
      modalRef.componentInstance.keyDateValue = event.keyDate; 
      modalRef.componentInstance.keyDateName = event.keyDateName;
  
      modalRef.result.then(
        (result) => {
          if(result)
        {
          this.loadKeyDates();
        }
    },
    () => {} // dismissed - do nothing
    );

  }

  showTravellingConsultants() {

    if (this.caseTypeId == 1 || this.caseTypeId == 7) {

      const modalRef = this.modalService.openXLModal(SelectConsultantComponent);
      modalRef.componentInstance.caseId = this.caseId;
      modalRef.componentInstance.showTravelling = true;

    }
  }

  cancelCase() {


      const modalRef = this.modalService.openWithOptions(CancelCaseComponent, {size: 'md'});
             
      modalRef.componentInstance.caseId = this.caseId
  
      modalRef.result.then(
        (result) => {
          if(result)
          {
              this.loadKeyDates();
              this.activeModal.dismiss()
          }
      },
      () => {} // dismissed - do nothing
      );
  }

  checkKeyDateVisible(keyId: number) {
    if (!this.keyDateTypes) return false;

    var key = this.keyDateTypes.find(x => x.keyDateTypeId == keyId);

    if (key) return true;

    return false;
  }

  getMonthForDate(date: any) {

    if (date) {
      var d = new Date(date);
      var curr_month = d.getMonth();
      var months = new Array("January", "February", "March",
        "April", "May", "June", "July", "August", "September",
        "October", "November", "December");
      return months[curr_month];
    }
    else
      return '';

  }


  viewHistory(){

    const modalRef = this.modalService.openWithOptions(KeyDatesHistoryComponent, {size: 'xl'});
             
    modalRef.componentInstance.caseId = this.caseId;
    
  }

  ngOnDestroy(){
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }
}
